import React from 'react';
import { withPermissionGuard } from './withPermissionGuard';
import NotFoundPageContent from '../../../containers/NotFoundPage/NotFoundPageContent';

/**
 * HOC for protecting route pages with a permission check and rendering NotFoundPageContent if access is denied.
 *
 * @param {string} permission - The required permission key.
 * @returns {function(React.ComponentType): React.ComponentType}
 *
 * @example
 * const ProtectedPage = withPagePermissionGuard(PERMISSIONS.MANAGE_SCRIPTS)(PageComponent);
 * // Use <Route Component={ProtectedPage} ... />
 */
export function withPagePermissionGuard(permission) {
    return withPermissionGuard(permission, <NotFoundPageContent loggedIn />);
}
